export default function normalizeQuotesByQuoteReqId(quotes: any[]) {
  const data: any[] = quotes.reduce((acc, el) => {
    const quoteData = {
      RFSdate: el?.quotes[0]?.RFSdate,
      createdAt: el?.quotes[0]?.createdAt,
      addressA: el?.quotes[0]?.addressA,
      addressB: el?.quotes[0]?.addressB,
      dueDate: el?.quotes[0]?.dueDate,
      productType: el?.quotes[0]?.type,
      description: el?.quotes[0]?.description,
      endCustomerName: el?.quotes[0]?.endCustomerName,
      source: el?.quotes[0]?.source,
      customerProjectNumber: el?.quotes[0]?.customerProjectNumber,
      quoteReqId: el?.quotes[0]?.quoteLines[0]?.quoteReqId || Math.random(),
      quoteLines: el?.quotes?.flatMap((quote: any, index: number) =>
        quote?.quoteLines.map((quoteLine: any) => ({
          ...quoteLine,
          status: quote?.status,
          quoteId: quote?.id,
          initiator: el?.quotes[index]?.initiator,
          implementer: el?.quotes[index]?.implementer,
        }))
      ),
    };

    return [...acc, quoteData];
  }, []);
  return data;
}
